import {
    colours as c
} from './colours';

const themes = {
    'white': {
		'base': c['white'],
        'light': c['charcoal-40'],
        'light-mid': c['charcoal-60'],
        'medium': c['charcoal-80'],
        'dark': c['charcoal'],
        'link': c['charcoal-60'],
        'link-alt': c['white'],
		'subtle': c['pebble'],
        'subtle-alt': c['earth'],
		'subtle-light': c['pebble'],
        'subtle-light-alt': c['earth'],
		'alt': c['red'],
        'alt-alt': c['white'],
		'primary': c['red-aa'],
        'primary-alt': c['white'],
        'secondary': c['red-20'],
        'secondary-alt': c['charcoal-80'],
        'tertiary': c['earth'],
        'tertiary-alt': c['pebble'],
        'quaternary': c['red-10'],
        'quaternary-alt': c['charcoal-80'],
        'disabled': c['charcoal-40'],
        'error': c['red-aa'],
        'success': c['earth'],
        'gradient': c['blush'],
		'shadow': c['earth-dark'],
        'overlay': c['black'],
		'curtain': c['earth-dark'],
    },
	'pebble': {
		'base': c['pebble'],
        'light': c['charcoal-40'],
        'light-mid': c['charcoal-60'],
        'medium': c['charcoal-80'],
        'dark': c['charcoal'],
        'link': c['charcoal-60'],
        'link-alt': c['white'],
		'subtle': c['sand'],
        'subtle-alt': c['earth'],
		'subtle-light': c['white'],
        'subtle-light-alt': c['charcoal-80'],
		'alt': c['red'],
        'alt-alt': c['white'],
		'primary': c['red-aa'],
        'primary-alt': c['white'],
        'secondary': c['red-20'],
        'secondary-alt': c['charcoal-80'],
        'tertiary': c['earth'],
        'tertiary-alt': c['pebble'],
        'quaternary': c['red-10'],
        'quaternary-alt': c['charcoal-80'],
        'disabled': c['charcoal-40'],
        'error': c['red-aa'],
        'success': c['earth'],
        'gradient': c['blush'],
		'shadow': c['earth-dark'],
        'overlay': c['black'],
		'curtain': c['earth-dark'],
    },
    'red': {
		'base': c['red-aa'],
        'light': c['red-20'],
        'light-mid': c['charcoal-60'],
        'medium': c['pebble'],
        'dark': c['white'],
        'link': c['white'],
        'link-alt': c['earth'],
		'subtle': c['red'],
        'subtle-alt': c['pebble'],
		'alt': c['red'],
        'alt-alt': c['white'],
		'primary': c['white'],
        'primary-alt': c['earth'],
        'secondary': c['red-20'],
        'secondary-alt': c['charcoal-80'],
        'tertiary': c['earth'],
        'tertiary-alt': c['pebble'],
        'quaternary': c['red-10'],
        'quaternary-alt': c['charcoal-80'],
        'disabled': c['charcoal-40'],
        'error': c['red-20'],
        'success': c['white'],
        'gradient': c['blush'],
		'shadow': c['earth-dark'],
        'overlay': c['black'],
		'curtain': c['earth-dark'],
    },
	'red-20': {
		'base': c['red-20'],
        'light': c['charcoal-40'],
        'light-mid': c['charcoal-60'],
        'medium': c['charcoal-80'],
        'dark': c['charcoal'],
        'link': c['charcoal-60'],
        'link-alt': c['white'],
		'subtle': c['pebble'],
        'subtle-alt': c['earth'],
		'alt': c['red'],
        'alt-alt': c['white'],
		'primary': c['red-aa'],
        'primary-alt': c['white'],
        'secondary': c['charcoal-80'],
        'secondary-alt': c['pebble'],
        'tertiary': c['earth'],
        'tertiary-alt': c['pebble'],
        'quaternary': c['red-10'],
        'quaternary-alt': c['charcoal-80'],
        'disabled': c['charcoal-40'],
        'error': c['red-aa'],
        'success': c['earth'],
        'gradient': c['blush'],
		'shadow': c['earth-dark'],
        'overlay': c['black'],
		'curtain': c['earth-dark'],
    },
	'overlay': {
		'base': c['charcoal'],
        'light': c['charcoal-40'],
        'light-mid': c['charcoal-60'],
        'medium': c['pebble'],
        'dark': c['white'],
        'link': c['white'],
        'link-alt': c['earth'],
		'subtle': c['charcoal-80'],
        'subtle-alt': c['pebble'],
		'alt': c['red'],
        'alt-alt': c['white'],
		'primary': c['red-aa'],
        'primary-alt': c['white'],
        'secondary': c['red-20'],
        'secondary-alt': c['charcoal-80'],
        'tertiary': c['earth'],
        'tertiary-alt': c['pebble'],
        'quaternary': c['red-10'],
        'quaternary-alt': c['charcoal-80'],
        'disabled': c['charcoal-40'],
        'error': c['red-aa'],
        'success': c['white'],
        'gradient': c['blush'],
		'shadow': c['earth-dark'],
        'overlay': c['black'],
		'curtain': c['earth-dark'],
    },
}

const innerThemes = {
    'white': {
		'primary': 'red',
		'subtle': 'pebble',
	},
	'pebble': {
		'primary': 'red',
        'secondary': 'red-20',
        'tertiary': 'white',
		'subtle': 'white',
        'menu': 'white',
        'header': 'white',
        'footer': 'white',
	},
	'red': {
		'primary': 'white',
	},
	'overlay': {
		'primary': 'red',
		'secondary': 'white',
	},
}

export {
    themes,
    innerThemes,
}
